import React, { useState, useEffect } from "react";
import OnlineCourses from "../allcourse/OnlineCourses";
import Heading from "../common/heading/Heading";
import "../allcourse/courses.css";
import { useNavigate } from "react-router-dom";

const HAbout2 = () => {
  const navigate = useNavigate();

  // Dark Mode state
  const [darkMode, setDarkMode] = useState(false);

  // Load dark mode preference from localStorage
  useEffect(() => {
    const savedMode = localStorage.getItem("darkMode");
    if (savedMode === "true") setDarkMode(true);
  }, []);

  // Save preference when darkMode changes
  useEffect(() => {
    localStorage.setItem("darkMode", darkMode);
  }, [darkMode]);

  const classesData = [
    {
      id: 1,
      name: "الصف الثالث الإعدادي",
      cover: "/images/2ps.png",
      time: "40 ساعة",
      priceAll: "400 جنيه",
      pricePer: "شهر",
    },
    {
      id: 2,
      name: "الصف الأول الثانوي",
      cover: "/images/1pss.png",
      time: "50 ساعة",
      priceAll: "500 جنيه",
      pricePer: "شهر",
    },
    {
      id: 3,
      name: "الصف الثاني الثانوي",
      cover: "/images/2pss.png",
      time: "45 ساعة",
      priceAll: "450 جنيه",
      pricePer: "شهر",
    },
    {
      id: 4,
      name: "الصف الثالث الثانوي",
      cover: "/images/3pss.png",
      time: "60 ساعة",
      priceAll: "600 جنيه",
      pricePer: "شهر",
    },
  ];

  return (
    <section className={`homeAbout ${darkMode ? "dark-mode" : ""}`}>
      <div className="containers">
        <Heading subtitle="دوراتنا" title="الصفوف الدراسية المتاحة" />

        <div className="coursesCard">
          <div className="grid2">
            {classesData.map((val) => (
              <div className={`card ${darkMode ? "dark-mode" : ""}`} key={val.id}>
                <div className="card-header">
                  <img src={val.cover} alt={val.name} />
                </div>

                <div className="card-body">
                  <h2>{val.name}</h2>
                  <div className="rate">
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <label>(5.0)</label>
                  </div>
                  <p className="teacher">
                    <strong>{val.teacher}</strong> • {val.time}
                  </p>
                </div>

                <div className="card-footer">
                  <h3>
                    {val.priceAll} / {val.pricePer}
                  </h3>
                  <button
                    className="outline-btn"
                    onClick={() => navigate("/signin")}
                  >
                    سجل الآن!
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HAbout2;
